// Whether the open tray renders inside `element` (TrayHost honours a tray's `container`). A
// fullscreen ordinal viewer asks this so its own Escape handling leaves a prompt shown inside it
// to the prompt.
export function isTrayOpenIn(
    state: { isTrayOpen: boolean; trayParams: Record<string, unknown> | null },
    element: Element | null,
): boolean {
    return !!element && state.isTrayOpen && state.trayParams?.container === element
}
